import { render, staticRenderFns } from "./SupplierAssignmentDialog.vue?vue&type=template&id=488de9c2&scoped=true&"
import script from "./SupplierAssignmentDialog.js?vue&type=script&lang=js&"
export * from "./SupplierAssignmentDialog.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488de9c2",
  null
  
)

export default component.exports